import React, {useState} from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import { useSystemMessage } from '../../../../hooks/useSystemMessage';
import useLoading from '../../../../hooks/useLoading';

import { roomMemberApi } from '../../../../apis/admin/room/roomMemberApi';

import { ChangeStateModalParams } from '../../../../types/admin/room';
import {ApiClientError} from "../../../../apis/errors";
import useAppRouter from "../../../../hooks/useAppRouter";
import {logError} from "../../../../libs/utils/logError";

interface ChangeStateModalProps {
  modalParams: ChangeStateModalParams | undefined;
  onSubmitted: (isChange: boolean) => Promise<void>;
}

export const ChangeStateModal = (props: ChangeStateModalProps) => {
  const { modalParams, onSubmitted } = props;

  const [isDisabled, setIsDisabled] = React.useState<boolean>(false);

  const withLoading = useLoading();
  const location = useLocation();
  const { success } = useSystemMessage();
  const [ apiClientError, setApiClientError] = useState<ApiClientError | null>(null);
  const { goto } = useAppRouter();


  React.useEffect(() => {
    const fetch = async () => {
      setIsDisabled(modalParams!.disabledFlg);
    };
    fetch();
  });


  const handleChangeState = async () => {
    withLoading(async () => {
      setApiClientError(null);

      try {
        await roomMemberApi.chngeStatus(
          {
            userId: modalParams!.userId,
            roomId: modalParams!.roomId,
          },
          {}
        );

        await onSubmitted(true);
        await success(`${modalParams!.userName} を${ isDisabled ? "再開" : "停止" }しました。`);

      } catch (e) {
        await logError(
          location.pathname,
          'ROOM参加者のROOM利用可能状態の変更に失敗しました。',
          e
        );

        if (e instanceof ApiClientError) {
          setApiClientError(e);
          return;
        }

        goto('internalServerError');
      }
    });
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted(false)}
        className="w-1/3"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
        style={{
          content: {
            position: 'fixed',
            top: '1rem'
          }
        }}
      >
        <section className="modal-background">
          <div className="form-modal-container">
            <div className="form-modal-title">
              <h1 className="font-semibold">確認</h1>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => onSubmitted(false)}
              >
                ×
              </button>
            </div>
            <div className="form-modal-content">
              <div className="mb-4 text-danger text-xs">
                { apiClientError?.message }
              </div>

              <div className="text-primary text-sm font-semibold grid grid-cols-1 w-full">
                <p>
                  { modalParams !== undefined ? modalParams.userName : "" } を
                  { isDisabled ? "再開" : "停止" }します。
                </p>
                <p>よろしいですか？</p>
              </div>
            
            </div>
            <div className="form-modal-footer-container">
              <div className="form-modal-footer">
                <button
                  className="btn-sub"
                  type="button"
                  onClick={() => onSubmitted(false)}
                >
                  キャンセル
                </button>
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() => handleChangeState()}
                >
                  更新
                </button>
                
              </div>
            </div>
          </div>
        </section>
      </ReactModal>
    </>
  );
}